import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Bone = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 576 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M153.7 144.8c6.9 16.3 20.6 31.2 38.3 31.2h192c17.7 0 31.4-14.9 38.3-31.2C434.4 116.1 462.9 96 496 96c44.2 0 80 35.8 80 80 0 30.4-17 56.9-42 70.4-3.6 1.9-6 5.5-6 9.6s2.4 7.7 6 9.6c25 13.5 42 40 42 70.4 0 44.2-35.8 80-80 80-33.1 0-61.6-20.1-73.7-48.8-6.9-16.3-20.6-31.2-38.3-31.2H192c-17.7 0-31.4 14.9-38.3 31.2C141.6 395.9 113.1 416 80 416c-44.2 0-80-35.8-80-80 0-30.4 17-56.9 42-70.4 3.6-1.9 6-5.5 6-9.6s-2.4-7.7-6-9.6c-25-13.5-42-40-42-70.4 0-44.2 35.8-80 80-80 33.1 0 61.6 20.1 73.7 48.8z"
  }));
});
Bone.displayName = 'Bone';
export var BoneDimensions = {
  height: 512,
  width: 576
};